import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, concatMap, switchMap, tap, take, first } from 'rxjs/operators';
import { Observable, EMPTY, of } from 'rxjs';
import { UsersService } from '@app/services/users/users.service';
import * as AppActions from './core.action';;
import { JwtService } from '@app/core/services/jwt.service';
import { Router } from '@angular/router';
import { AuthenticationStateService } from '@app/core/services/authentication-state.service';
import { LocationsService } from '@app/services/locations/locations.service';
import { MatDialog } from '@angular/material/dialog';
import { MessageModalComponent } from '@app/shared/components/message-modal/message-modal.component';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { PermissionModalComponent } from '@app/shared/components/permission-modal/permission-modal.component';

@Injectable()
export class CoreEffects {

  login = createEffect(() => {
    return this.actions$.pipe(

      ofType(AppActions.login),
      switchMap((action) => {
        return this._jwt.onValidateAccount(action).pipe(
          tap((locations) => {
            // localStorage.setItem('token', user.access_token);
            // localStorage.setItem('locUsesCountingModule', user.user.locUsesCountingModule);
            // localStorage.setItem('locUsesAssetModule', user.user.locUsesAssetModule);
            // this._router.navigate(['/']);
            // this._authentication.setAuthState(user.user);
            return AppActions.loginSuccess({ locations })
          }),
          catchError(( error ) => {
            return of(AppActions.loginFail({error }))
          }))
      }),
    );
  });

  loadLocations = createEffect(() => {
    return this.actions$.pipe(

      ofType(AppActions.loadLocations),
      switchMap(() => {
        return this._locations.readLocationImages().pipe(
          map((locations) => {
            return AppActions.loadLocationsSuccess({ locations })
          }),
          catchError(( error ) => {
            return of(AppActions.loginFail({error }))
          }))
      }),
    );
  });

  loadMe$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(AppActions.loadMe),
      switchMap((action) => {
        return this._users.me().pipe(
          map(({ user }) => {
            return AppActions.loadMeSuccess({ user })
          }),
          catchError(error => of(AppActions.loadMeFailure({ error }))))
      })
    );
  });

  updateMe$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(AppActions.updateMe),
      switchMap((action) => {
        return this._users.updateMe(action.form).pipe(
          map((user) => {
            return AppActions.updateMeSuccess({ user: user})
          }),
          catchError(error => of(AppActions.updateMeFailure({ error }))))
      })
    );
  });

  updateLocation$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(AppActions.updateLocation),
      switchMap((action) => {
        return this._locations.readLocations(action.form, action.id).pipe(
          map((locatoin) => {
            return AppActions.updateLocationSuccess({ location: location})
          }),
          catchError(error => of(AppActions.updateMeFailure({ error }))))
      })
    );
  });


  changePassword$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(AppActions.changePassword),
      switchMap((action) => {
        return this._users.changePassword(action.form).pipe(
          map((user) => {
            this._toaster.success(this._translation.instant('user.profile.passwordChanged'));
            this.dialog.closeAll();
            return AppActions.changePasswordSuccess({ user: user})
          }),
          catchError(error => 
            {
              this._toaster.error(this._translation.instant(error.error.message));    
              return of(AppActions.changePasswordFailure({ error }))
            }
          ))
      })
    );
  });

  showErrorMessage$ = createEffect(() =>
  this.actions$.pipe(
    ofType(AppActions.showErrorMessage),
    tap((action) => {
      this.dialog.open(MessageModalComponent, {
        minWidth: '30vw',
        maxWidth: '700px',
        data: {
          title: action.title,
          body: action.body,
          show_upgrade: action.show_upgrade
        }
      });
    })
  ),
  { dispatch: false }
);

showPermissionMessage$ = createEffect(() =>
  this.actions$.pipe(
    ofType(AppActions.showPermissionMessage),
    tap((action) => {
      this.dialog.open(PermissionModalComponent, {
        minWidth: '30vw',
        maxWidth: '700px',
        disableClose: true,
        data: {
          title: action.title,
          body: action.body
        }
      });
    })
  ),
  { dispatch: false }
);

  constructor(
    private actions$: Actions, 
    private _users: UsersService, 
    private _jwt: JwtService, 
    private _router: Router,
    private _translation: TranslateService,
    private _toaster: ToastrService,
    private dialog: MatDialog,
    private _authentication: AuthenticationStateService,
    private  _locations: LocationsService
    ) { }

}
